import i18next from "config/i18next";
import { ValidateTimeIntervalParamsType } from "utils/types";
import {
  validateHourDifference,
  validateTimeInterval,
} from "utils/validations";
import * as yup from "yup";
import { FrequencyType } from "./types";

const requiredMessage = i18next.t("validations:required");
const frequencyRequiredMessage = i18next.t("validations:frequencyRequired");

const validationHourParams = {
  minDifference: 30,
  minMessage: i18next.t("slotCreation:minTimeDifferenceError"),
  maxDifference: 360,
  maxMessage: i18next.t("slotCreation:maxTimeDifferenceError"),
  field: "slotTime.end",
};

const validationTimeIntervalParams: ValidateTimeIntervalParamsType = {
  message: i18next.t("slotCreation:timeIntervalError"),
  field: "",
  interval: 15,
};

const validateSlotTime = (context: yup.TestContext<any>) =>
  validateHourDifference(context, validationHourParams);

const validateSlotIntervalTime = (
  value: string,
  context: yup.TestContext<any>,
  field: string
) =>
  validateTimeInterval(value, context, {
    ...validationTimeIntervalParams,
    field,
  });

const validateFrequency = (values: FrequencyType) => {
  if (!values) return false;
  return Object.values(values).some((capacityValue: number | null) => capacityValue !== null && capacityValue >= 0);
};

const slotTime = yup.object({
  initial: yup
    .string()
    .nullable()
    .required(requiredMessage)
    .test("timeValidation", (value, context) => {
      if (!value) return true;
      return validateSlotTime(context);
    })
    .test("intervalValidation", (val, ctx) => {
      if (!val) return true;
      return validateSlotIntervalTime(val, ctx, "slotTime.initial");
    }),
  end: yup
    .string()
    .nullable()
    .required(requiredMessage)
    .test("timeValidation", (value, context) => {
      if (!value) return true;
      return validateSlotTime(context);
    })
    .test("intervalValidation", (val, ctx) => {
      if (!val) return true;
      return validateSlotIntervalTime(val, ctx, "slotTime.end");
    }),
});

export const validationSchema = yup.object({
  region: yup.object().required(requiredMessage),
  workzone: yup.object().required(requiredMessage),
  slotTime: slotTime,
  frequency: yup
    .object()
    .test("frequencyValidation", frequencyRequiredMessage, (value) => validateFrequency(value as unknown as FrequencyType))
    .required(),
});
